// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    /*Colors*/
    --lightPurple: #f3f0f8;
    --darkerPurple: #EEDEF6;
    /*Sizes*/
    --borderWidth: 15px;
    --sectionMarginBottom: 25px;
}`, "",{"version":3,"sources":["webpack://./src/styles/assessments/AssessmentDefaults.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;AAC/B","sourcesContent":[":root{\n    /*Colors*/\n    --lightPurple: #f3f0f8;\n    --darkerPurple: #EEDEF6;\n    /*Sizes*/\n    --borderWidth: 15px;\n    --sectionMarginBottom: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
